import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Close modal on escape key
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.boundCloseOnEscape)

    // Close modal when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.element.addEventListener("click", this.boundCloseOnClickOutside)

    // Auto-open if this modal was loaded via Turbo Frame
    if (this.element.hasAttribute('data-turbo-temporary')) {
      this.open()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundCloseOnEscape)
    this.element.removeEventListener("click", this.boundCloseOnClickOutside)

    // Restore body scroll when modal is closed
    document.body.style.overflow = 'auto'
  }

  open() {
    this.element.classList.remove('hidden')
    document.body.style.overflow = 'hidden'

    // Focus the first input in the modal
    const firstInput = this.element.querySelector('input:not([type="hidden"]), textarea, select')
    if (firstInput) {
      firstInput.focus()
    }
  }

  close() {
    this.element.classList.add('hidden')
    document.body.style.overflow = 'auto'
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.element.classList.contains('hidden')) {
      this.close()
    }
  }

  closeOnClickOutside(event) {
    // Close modal only if clicking on the backdrop (modal element itself)
    if (event.target === this.element) {
      this.close()
    }
  }
}